import React from 'react';
import { Fade, IconButton, Grid, Divider } from '@material-ui/core';

import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { CommonButton } from '../Buttons';

import { GridClose, GridTitle, ModalContent, ModalPosition, ModalTitle, StyledItem, OverflowModal } from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledModal = ({ children, open, action, width }) => {
  return (
    <ModalPosition width={width} open={open} onClose={() => action()} closeAfterTransition>
      <Fade in={open}>
        <ModalContent> {children} </ModalContent>
      </Fade>
    </ModalPosition>
  );
};

export const HeaderModal = ({ title, customtitle = '', action }) => {
  return (
    <>
      <Grid container>
        <GridTitle item xs={11}>
          {customtitle ? customtitle : <ModalTitle variant="h5">{title}</ModalTitle>}
        </GridTitle>
        <GridClose customtitle={customtitle} item xs={1}>
          <IconButton onClick={() => action()}>
            <FontAwesomeIcon icon={faTimes} />
          </IconButton>
        </GridClose>
      </Grid>
      <Divider style={{ marginBottom: '20px' }} />
    </>
  );
};

export const FooterModal = ({ successLabel, successAction, successActive, backLabel, backAction }) => {
  return (
    <>
      <Divider style={{ marginTop: '20px' }} />
      <Grid container justify={successAction && backAction ? 'space-between' : 'center'}>
        {backAction && (
          <StyledItem item xs={2}>
            <CommonButton label={backLabel ?? 'Cancelar'} action={() => backAction()} />
          </StyledItem>
        )}
        {successAction && (
          <StyledItem item xs={2}>
            <CommonButton label={successLabel ?? 'Confirmar'} action={() => successAction()} disabled={!successActive || false} />
          </StyledItem>
        )}
      </Grid>
    </>
  );
};

export const ModalAction = ({ children, title, customtitle = '', open, successAction, successLabel, successActive, backLabel, backAction, width }) => {
  return (
    <StyledModal width={width} open={open} action={backAction}>
      <HeaderModal title={title} customtitle={customtitle} action={backAction} />
      <OverflowModal>{children}</OverflowModal>
      <FooterModal
        successLabel={successLabel ?? 'Salvar'}
        successActive={successActive}
        successAction={successAction}
        backLabel={backLabel ?? 'Fechar'}
        backAction={backAction}
      />
    </StyledModal>
  );
};
